<div class="d-flex align-items-center justify-content-center pt-3">
  <button type="button" class="btn-close" aria-label="Close" (click)="thanksPage ? closeModal() : dismissModal()">
    <mat-icon class="icon-20 strict" svgIcon="close-circle"></mat-icon>
  </button>
  @if (srcIframe) {
    <iframe
      title="npsForm"
      class="iframe-form"
      [ngClass]="{
        thanks: thanksPage,
      }"
      [src]="srcIframe | safeResourceUrl"
    ></iframe>
  }
</div>
<div class="modal-footer">
  @if (!thanksPage) {
    <button class="footer-button" (click)="dismissModal()">
      <span>{{ 'nps-form.remind-me-later' | translate }}</span>
    </button>
  } @else {
    <button class="footer-button" (click)="closeModal()">
      <span>{{ 'nps-form.close' | translate }}</span>
    </button>
  }
</div>
